import {
  differenceInHours,
  differenceInMinutes,
  differenceInSeconds,
  parseISO,
} from "date-fns";

export const hoursAgo = (dateString: string) => {
  const date = parseISO(dateString);
  if (!date) {
    return 0;
  }

  return differenceInHours(new Date(), date);
};

export const minutesAgo = (dateString: string) => {
  const date = parseISO(dateString);
  if (!date) {
    return 0;
  }
  return differenceInMinutes(new Date(), date);
};

export const secondsAgo = (dateString: string) => {
  const date = parseISO(dateString);
  if (!date) {
    return 0;
  }
  return differenceInSeconds(new Date(), date);
};

export const secondsAgoFromTimestamp = (
  timestamp: number,
  inMiliseconds = false
) => {
  const date = new Date(inMiliseconds ? timestamp : timestamp * 1000);

  if (!date) {
    return 0;
  }
  return differenceInSeconds(new Date(), date);
};
